<div class="detail-container" [class.in-dialog]="inDialog" [nbSpinner]="!!(loading$|async) || !form">
  @if (showCard) {
    <nb-card>
      <nb-card-header><ng-container [ngTemplateOutlet]="header"></ng-container></nb-card-header>
      <!-- cdkScrollable feeds the body's scroll events into Nebular's NbScrollDispatcherAdapter so
           open overlays (popover, tooltip, select) reposition instead of sticking to stale screen
           coordinates while the dialog body scrolls (WR-2515 review). -->
      <nb-card-body cdkScrollable><ng-container [ngTemplateOutlet]="body"></ng-container></nb-card-body>
      <nb-card-footer><ng-container [ngTemplateOutlet]="footer"></ng-container></nb-card-footer>
    </nb-card>
  } @else {
    <div class="header"><ng-container [ngTemplateOutlet]="header"></ng-container></div>
    <div class="body"><ng-container [ngTemplateOutlet]="body"></ng-container></div>
    <div class="footer"><ng-container [ngTemplateOutlet]="footer"></ng-container></div>
  }
</div>

<ng-template #header>
  <div class="header-row">
    @if (showTitle) {
      <h5 class="title">TGA</h5>
    }
    <div class="header-actions">
      @if (!isNew && !disableEdit && canEdit()) {
        <wr-edit-delete-button-group
          (edit)="enable()"
          (delete)="onDelete()">
        </wr-edit-delete-button-group>
      }
      @if (showCloseButton) {
        <button nbButton ghost status="primary" (click)="closed.emit()">
          <nb-icon pack="eva" icon="close-outline"></nb-icon>
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #body>
  @if (form) {
    <hau-form [formGroup]="form">
      <hau-form-field label="TGA Typ" [validation]="form.validation.equipment" cols="6">
        <wr-tga-type-select [tenantId]="currentTenantId()" formControlName="equipment"></wr-tga-type-select>
      </hau-form-field>
      <hau-form-field label="Anzahl" [validation]="form.validation.quantity" cols="6">
        <input nbInput fullWidth type="number" formControlName="quantity">
      </hau-form-field>
      <hau-form-field label="Gebäude" [validation]="form.validation.building" cols="6">
        <wr-building-select formControlName="building"></wr-building-select>
      </hau-form-field>
      <hau-form-field label="Gebäude Teil" [validation]="form.validation.buildingSectionId" cols="6">
        <!-- default `block` assumes nothing scrolls while the options are open — untrue inside the
             scrolling dialog body; `reposition` keeps the list attached to the field. -->
        <nb-select fullWidth formControlName="buildingSectionId"
                   scrollStrategy="reposition"
                   placeholder="Bitte Gebäude wählen">
          @for (buildingSection of buildingSections(); track buildingSection.id) {
            <nb-option [value]="buildingSection.id">{{buildingSection.address.street + ' ' + buildingSection.address.number}}</nb-option>
          }
        </nb-select>
      </hau-form-field>
      <hau-form-field label="Bilder aus Prüfpunktzeilen" [validation]="form.validation.inspectionEntryAttachments" cols="12">
        <wr-multi-attachment-control formControlName="inspectionEntryAttachments" [readOnly]="true"></wr-multi-attachment-control>
      </hau-form-field>
      <hau-form-field label="Bilder & Dokumentenliste der TGA" [validation]="form.validation.attachments" cols="12">
        <wr-multi-attachment-control formControlName="attachments"
                                     nbTooltip="Datei hinzufügen">
        </wr-multi-attachment-control>
      </hau-form-field>
    </hau-form>
  }

  @if (showCollections) {
    <div class="spacer"></div>
    <wr-custom-field-collections
      [formReadonly]="!form?.enabled"
      [customFieldCollections]="customFieldCollections()"
      [instances]="customFieldCollectionInstances()">
    </wr-custom-field-collections>
  }
</ng-template>

<ng-template #footer>
  @if (canEdit() && showFooter) {
    <div class="footer">
      <button size="medium"
              nbButton
              status="basic"
              [disabled]="!isEditing"
              (click)="cancelled.emit()">
        Abbrechen
      </button>
      <button size="medium"
              nbButton
              status="primary"
              data-cy="building-equipment-submit"
              [disabled]="!form?.enabled || isSaving"
              (click)="submit()">
        Speichern
      </button>
    </div>
  }
</ng-template>
